import { useState } from "react";
import { EventsSidebar, LARGURA_SIDEBAR } from "./EventsSidebar";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

interface EventsLayoutProps {
  children: React.ReactNode;
}

export function EventsLayout({ children }: EventsLayoutProps) {
  // No celular a barra é gaveta (começa fechada); no desktop fica sempre aberta.
  const isMobileInicial = typeof window !== "undefined" && window.innerWidth < 1024; // o mesmo corte do useIsMobile
  const [sidebarCollapsed, setSidebarCollapsed] = useState(isMobileInicial);
  const isMobile = useIsMobile();

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    // `ds-painel`: a casca do painel do core — fundo em --bg-surface, barra e blocos claros.
    <div className="ds-painel min-h-screen bg-background flex">
      <EventsSidebar
        collapsed={sidebarCollapsed}
        onToggle={toggleSidebar}
      />

      <main
        className={cn("flex-1 min-h-0", isMobile && "pt-14")}
        style={{ marginLeft: isMobile ? 0 : LARGURA_SIDEBAR }}
      >
        <div className="p-6 max-w-screen-2xl mx-auto h-full">
          {children}
        </div>
      </main>
    </div>
  );
}